import { useSize } from "ahooks";

const EXTERNAL_LAYOUT_SIDE_CLASS_NAME = 'mpc-external-layout-sider';

export default function useLayoutContentWidth() {
  const taggetSider = document.getElementsByClassName(EXTERNAL_LAYOUT_SIDE_CLASS_NAME)[0]
  const size = useSize(taggetSider);

  return window.innerWidth - size?.width;
}